import React from "react";

interface Props {
  category: string;
}

const BlogCategory = ({ category }: Props) => {
  return (
    <p className="ss:text-primary2-600 ss:group-hover:text-neutral-50 ss:group-hover:bg-neutral-900 ss:group-hover:border-primary1-400 ss:text-[10px] ss:blog-card__category ss:duration-200 ss:px-4 ss:py-2 ss:rounded-lg ss:w-max ss:bg-error-50/10 ss:border ss:border-primary2-600 ss:text-left ss:font-bold">
      {category}
    </p>
  );
};

export default BlogCategory;
